module.exports = __webpack_public_path__ + "img/head-icon.16fd8029.png";